import { render, staticRenderFns } from "./pbnumExample.vue?vue&type=template&id=02364704&scoped=true"
import script from "./pbnumExample.vue?vue&type=script&lang=js"
export * from "./pbnumExample.vue?vue&type=script&lang=js"
import style0 from "./pbnumExample.vue?vue&type=style&index=0&id=02364704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02364704",
  null
  
)

export default component.exports